import React from "react";
import { Fragment } from "react";
import QuestionMultiplayer from "./QuestionMultiplayer.js";
import Button from "../Button.js";
import { ModalContext } from "../../contexts/ModalContext.js";
import { Link } from "react-router-dom";
//import Timer from "./Timer.js";

class PageQuizMultiplayer extends React.Component {
  static contextType = ModalContext;

  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      room: props.room,
      TimePerQuestion: 20,
      nb_questions: 5,
      Questions: props.room.state.toJSON().listQuestions,
      index_q: 0,
      start: false,
      isFinished: false,
      idQuestionWrong: [],
      time: 0,
      error: "",
      words: [],
      wasOpen: false,
      leaderboard: [],
      playerScores: {},
      gameWinner: "",
    };

    this.timerID = setInterval(() => this.tick(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  componentDidMount() {
    this.state.room.onMessage("playerScores", (playerScores) => {
      this.setState({ playerScores });
    });

    // Listen for the game winner.
    this.state.room.onMessage("gameWinner", (winner) => {
      this.setState({ gameWinner: winner });
    });
  }

  tick() {
    if (this.state.TimePerQuestion > 0) {
      this.setState({
        TimePerQuestion: this.state.TimePerQuestion - 1,
      });
    } else {
      this.badAnswer("Time Out");
    }
  }

  resultUpdate(){
    return new Promise((resolve, reject) => {
    //const scoreValue = Object.values(this.state.playerScores)[0];
    fetch(process.env.REACT_APP_API_URL + "/multiplayerResults",{
      method: "POST",
      body: JSON.stringify({
          total_question: this.state.nb_questions,
          nb_good: this.state.nb_questions - this.state.idQuestionWrong.length,
          time_remaining: this.state.time,
          time_per_question: this.state.TimePerQuestion,
          room_id: this.state.room.id,
          session_id: this.state.room.sessionId,
          score: this.state.nb_questions - this.state.idQuestionWrong.length,
          
      }),
      headers: {
          "Content-type": "application/json; charset=UTF-8",
      }
      })
      .then(res =>res.json())
      .then((res) => {
        console.log(res);
        resolve(res); // Resolve the promise
    })
      .catch((err) => {console.log(err)})

    });

  }



  end() {
    this.setState({ isFinished: true });
    this.state.room.send("finish", {
        error: this.state.idQuestionWrong.length,
    });
  
    this.resultUpdate()
        .then(() => {
            const room_id = this.state.room.id;
            console.log(room_id); // Update leaderboard every 5 seconds, for 3 times
            let updateCount = 0;
            const leaderboardInterval = setInterval(() => {
                updateCount++;
                const isFinalCall = updateCount === 3;
                this.retrieveResults(room_id, isFinalCall);
                if (isFinalCall) {
                    clearInterval(leaderboardInterval);
                }
            }, 5000);
        })
        .catch(error => console.error('Error:', error));
  }
  


  retrieveResults(room_id, finalCall = false) {
    fetch(`${process.env.REACT_APP_API_URL}/multiplayerResults/${room_id}`)
        .then(response => response.json())
        .then(results => {
            // Sort results based on score and time_per_question
            const updatedResults = results.map(res => {
              return {
                  ...res,
                  calculatedScore: (res.nb_good / res.total_question * 100).toFixed(2),
                  calculatedTime: (100 - res.time_remaining / (res.time_per_question * res.total_question) * 100).toFixed(2)
              };
          });

          // Sort updatedResults based on calculatedScore and calculatedTime
    updatedResults.sort((a, b) => {
        if (b.calculatedScore === a.calculatedScore) {
            return parseFloat(a.calculatedTime) - parseFloat(b.calculatedTime);
        }
        return parseFloat(b.calculatedScore) - parseFloat(a.calculatedScore);
    });

  
            // Update the state with the sorted results to re-render the component
            this.setState({ leaderboard: updatedResults  }, () => {
                // Check if this is the final call
                if (finalCall) {
                    // Check if the top result has the same session_id as the current session
                    if (this.state.leaderboard.length > 0 && this.state.leaderboard[0].session_id === this.state.room.sessionId) {
                        alert('Congratulations, you won!!!');
                    } else {
                        alert('Too bad, you lost, try again!!!');
                    }
                }
            });
        })
        .catch(error => console.error('Error:', error));
      }
    

  


  goodAnswer() {
    this.setState({
      index_q: this.state.index_q + 1,
      TimePerQuestion: 20, // Resetting the timer
    });

    const sessionId = this.state.room.sessionId;
  const updatedScores = { ...this.state.playerScores };
  updatedScores[sessionId] = (updatedScores[sessionId] || 0) + 1;

  this.setState({ playerScores: updatedScores });


    if (this.state.index_q + 1 === this.state.Questions.length) this.end();
  }


  badAnswer(err) {
    var tmp = this.state.idQuestionWrong;
    tmp.push(this.state.index_q);
    this.setState({
      idQuestionWrong: tmp,
      TimePerQuestion: 20, // Resetting the timer
    });
    this.continue();
  }

  determineWinner() {
    let winner = "";
    let highestScore = -1;
  
    for (const sessionId in this.state.playerScores) {
      if (this.state.playerScores[sessionId] > highestScore) {
        highestScore = this.state.playerScores[sessionId];
        winner = sessionId;
      }
    }
  
    this.setState({ gameWinner: winner });
  }

  
  continue() {
    this.setState({
      isPause: false,
      popins: false,
      index_q: this.state.index_q + 1,
    });
    if (this.state.index_q + 1 === this.state.Questions.length) {
      this.end();
    }
  }

  goBackToCourse() {
    window.location.replace(process.env.REACT_APP_TENSEMAP_URL);
  }

  handleTime = (e) => {
    this.setState({ TimePerQuestion: e.target.value });
  };

  handleNote = (e) => {
    this.setState({ note: e.target.value });
  };

  handleNbQuestion = (e) => {
    this.setState({ nb_questions: e.target.value });
  };

  render() {
    if (
      this.context.isOpen !== this.state.isPause &&
      this.context.isOpen !== this.state.wasOpen
    )
      this.setState({
        isPause: this.context.isOpen,
        wasOpen: this.context.isOpen,
      });

    // data to print
    let selectTime = (
      <select defaultValue="20" onChange={this.handleTime}>
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="15">15</option>
        <option value="20">20</option>
      </select>
    ); // 5/10/15/20
    let selectNbQuestion = (
      <select defaultValue="5" onChange={this.handleNbQuestion}>
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="40">40</option>
      </select>
    ); // 5/10/20/40
    let informationDefinition = (
      <h3>
        You can double click a word to see its definition (While you read the
        definition, the timer is stoped)
      </h3>
    );

    // state of the batch
    let question =
      this.state.index_q >= 0 &&
      this.state.index_q < this.state.Questions.length ? (
        <QuestionMultiplayer
          onEnd={() => {
            this.badAnswer("Time Out");
          }}
          isFinished={this.state.isFinished}
          isPause={this.state.isPause}
          time={this.state.TimePerQuestion}
          onGood={() => {
            this.goodAnswer();
          }}
          onBad={() => {
            this.badAnswer("You made a mistake");
          }}
          question={this.state.Questions[this.state.index_q].question_title}
          a={[
            this.state.Questions[this.state.index_q].answer_title_a,
            this.state.Questions[this.state.index_q].answer_title_b,
            this.state.Questions[this.state.index_q].answer_title_c,
            this.state.Questions[this.state.index_q].answer_title_d,
          ]}
          ga={this.state.Questions[this.state.index_q].right_answer}
        />
      ) : null;
    let correction =
      this.state.index_q === this.state.Questions.length ? (
        <Fragment>
          <p>
            Your result is{" "}
            {this.state.Questions.length - this.state.idQuestionWrong.length} /{" "}
            {this.state.Questions.length}
          </p>
          {this.state.Questions.map((question, index) => {
            if (this.state.idQuestionWrong.indexOf(index) >= 0) {
              //console.log(question.question_title);
              return (
                <Fragment key={index}>
                  <p>{question.question_title}</p>
                  <p>The answer is: {question.right_answer}</p>
                  <p>
                    a:{question.answer_title_a} b:{question.answer_title_b} c:
                    {question.answer_title_c} d:{question.answer_title_d}
                  </p>
                </Fragment>
              );
            }
            return <Fragment key={index}></Fragment>;
          })}
        </Fragment>
      ) : null;

    return (
  <div className="mt-5" style={{ marginTop: "100px"}}> 
    {question}
    {correction}

    <div>
      <h3>Leaderboard</h3>
      <table className="table" id="leaderboard"> {/* Bootstrap class for styling tables */}
        <thead>
          <tr>
            <th>Rank</th>
            <th>Player</th>
            <th>Score</th>
            <th>Time Used</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
  {this.state.leaderboard && this.state.leaderboard.map((result, index) => (
    <tr key={index}>
      <td>{index + 1}</td>
      <td>{result.session_id}</td>
      <td>{result.calculatedScore}%</td> {/* Display the calculated score */}
      <td>{result.calculatedTime}%</td> {/* Display the calculated time */}
      <td className={index === 0 ? 'text-success' : 'text-danger'}>
        {index === 0 ? 'Winner' : 'Loser'}
      </td>
    </tr>
  ))}
</tbody>

      </table>
    </div>

    {this.state.gameWinner && (
      <p className="text-primary">Winner: {this.state.gameWinner}</p> 
    )}
  </div>
);

  }
}

export default PageQuizMultiplayer;
